import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";

export const useProjectIqWorkspacesPageStyles = makeStyles({
  page: {
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
    backgroundColor: "#ffffff",
  },
  topBar: {
    position: "sticky",
    top: 0,
    zIndex: 5,
    height: "56px",
    minHeight: "56px",
    flexShrink: 0,
    borderBottom: `1px solid ${projectIqTokens.line}`,
    background: "rgba(255,255,255,0.85)",
    backdropFilter: "blur(8px)",
    display: "flex",
    alignItems: "center",
    padding: "0 32px",
  },
  topBarTitle: {
    fontSize: "15px",
    fontWeight: "700",
    color: projectIqTokens.ink,
    letterSpacing: "-0.01em",
  },
  content: {
    maxWidth: "1180px",
    margin: "0 auto",
    padding: "34px 32px 64px",
    width: "100%",
    boxSizing: "border-box",
  },
  pageTitle: {
    fontSize: "30px",
    fontWeight: "800",
    letterSpacing: "-0.02em",
    color: projectIqTokens.ink,
    margin: "0 0 6px",
    lineHeight: "1.2",
  },
  searchRow: {
    display: "flex",
    gap: "12px",
    margin: "20px 0 22px",
    alignItems: "center",
  },
  searchBox: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    gap: "10px",
    background: projectIqTokens.card,
    border: `1px solid ${projectIqTokens.line}`,
    borderRadius: "12px",
    padding: "0 14px",
    height: "46px",
    boxShadow: projectIqTokens.shadowSm,
  },
  searchInput: {
    border: "none",
    outline: "none",
    flex: 1,
    fontSize: "14.5px",
    color: projectIqTokens.ink,
    background: "transparent",
    ":focus-visible": {
      outline: `2px solid ${projectIqTokens.teal}`,
      outlineOffset: "2px",
    },
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
    gap: "16px",
  },
  emptyState: {
    textAlign: "center" as const,
    color: projectIqTokens.muted,
    padding: "64px 0",
    fontSize: "14px",
  },
  skeletonCardContent: {
    display: "flex",
    flexDirection: "column",
    gap: "14px",
  },
  skeletonCard: {
    borderRadius: "16px",
    border: `1px solid ${projectIqTokens.line}`,
    padding: "22px 18px",
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    backgroundColor: projectIqTokens.card,
    boxShadow: projectIqTokens.shadowSm,
    minHeight: "120px",
  },
  skeletonCardName: {
    height: "18px",
    borderRadius: "6px",
    width: "62%",
  },
  skeletonCardSubname: {
    height: "12px",
    borderRadius: "4px",
    width: "38%",
  },
});
